import baseUrl from "../energyApiHost";
import { callApi } from "./util";

const getAlerts = (after, status, storeId, sortBy, pageSize) => {
  let url = `${baseUrl}alerts`;

  const parameters = [];

  if (after) {
    parameters.push(`after=${after}`);
  }

  if (status) {
    status.forEach(status => {
      parameters.push(`status=${status}`);
    });
  }

  if (storeId) {
    parameters.push(`storeId=${storeId}`);
  }

  if (sortBy) {
    parameters.push(`sortBy=${sortBy}`);
  }

  if (pageSize) {
    parameters.push(`pageSize=${pageSize}`);
  }

  if (parameters.length > 0) {
    url += "?" + parameters.join("&");
  }

  return callApi(url);
};

const getAlert = alertId => {
  const url = `${baseUrl}alerts/${alertId}`;
  return callApi(url);
};

const updateAlertIncludeDataInBaseline = (alertId, includeDataInBaseline) => {
  const url = `${baseUrl}alerts/${alertId}/include-data-in-baseline`;

  const headers = {
    "Content-Type": "application/json"
  };

  const config = {
    headers,
    method: "PATCH",
    body: JSON.stringify({
      includeDataInBaseline: includeDataInBaseline
    })
  };

  return callApi(url, config);
};

const updateAlertStatus = (alertId, status, closedReason) => {
  const url = `${baseUrl}alerts/${alertId}`;

  const headers = {
    "Content-Type": "application/json"
  };

  const config = {
    headers,
    method: "PATCH",
    body: JSON.stringify({
      status: status,
      closedReason: closedReason
    })
  };

  return callApi(url, config);
};

export default {
  getAlerts,
  getAlert,
  updateAlertStatus,
  updateAlertIncludeDataInBaseline
};
